// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"1f48e447","343":"27bf5fbf","395":"1a6bc836","560":"751d2a5d","723":"dbb6e342","947":"f7b38a30","991":"48b78d28"}[chunkId] + ".chunk.css";
};